export default "__VITE_ASSET__7f96513d__"